import { render, staticRenderFns } from "./DoubleBounce.vue?vue&type=template&id=2483771b&scoped=true&"
import script from "./DoubleBounce.vue?vue&type=script&lang=js&"
export * from "./DoubleBounce.vue?vue&type=script&lang=js&"
import style0 from "./DoubleBounce.vue?vue&type=style&index=0&id=2483771b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483771b",
  null
  
)

export default component.exports